import React, { useEffect, useRef, useState } from 'react'
import { Alert, Button, Badge, Spinner, Modal, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { serGetCrsytalNum, serGetseekHelp, serIsSubject, serSetSubject } from '../../axios';
import { setCrsytalS } from '../../store/modules/crsytal';
import langList from '../../utils/languagelist.json';
import { useNavigate } from 'react-router-dom';
import { setHelpContent, setHelpFlag, setHelpNode } from '../../store/modules/helpinfo';
import { setCheckShow } from '../../store/modules/helpdialogshow';
import Alertwin from '../Alertwin';
import { isAllCandidate, timuHxArray, timuKoArray, toScArray } from '../../utils/publicfunction';

function timuArray(str){
  let board = [];
  for (let i = 0; i < 9; i++) {
    board.push(str.slice(i * 9, (i + 1) * 9).split('').map(Number));
  }
  return board
}

// 检查在(board[row][col]位置)放入(num)是否有效
function isValid(board, row, col, num) {
  for (let i = 0; i < 9; i++) {
    if (board[row][i] === num || board[i][col] === num || 
      board[Math.floor(row / 3) * 3 + Math.floor(i / 3)][Math.floor(col / 3) * 3 + i % 3] === num) {
      return false;
    }
  }
  return true;
}

// 使用回溯算法解决数独
function solve(board) {
  for (let row = 0; row < 9; row++) {
    for (let col = 0; col < 9; col++) {
      if (board[row][col] === 0) {
        for (let num = 1; num <= 9; num++) {
          if (isValid(board, row, col, num)) {
            board[row][col] = num;
            if (solve(board)) {
                return true;
            }
            board[row][col] = 0;
          }
        }
        return false;
      }
    }
  }
  return true;
}

// 判断解答是否错误
function isKoError(tt,board) {
  for(let i=0;i<81;i++){
    const num=tt[i].nu[1].slice(1)*1
    const shh=tt[i].sh*1
    if (shh===2 && num !==0){
      const r=i/9|0;
      const c=i%9
      if(board[r][c]!==num){
        return {r,c}
      }
    }
  }
  return false
}

function AB(r, c) {
  let row = String.fromCharCode(65 + r);
  let col = c + 1;
  return row + col;
}

// 判断解题是否结束
function isComplate(tt){
  const tikonum=tt.map(v=>v.nu[0]==='0'?v.nu[1]:v.nu[0]).join('');
  if(!tikonum.includes('0'))return true;
  return false;
}

export default function Helpplate() {
  const [isHovered,setIsHovered]=useState(false)
  // 寻求帮助面板背景色
  const {hp}=useSelector((state)=>state.colorplate);
  const {lg}=useSelector((state)=>state.language);
  const {usern,expires}=useSelector((state)=>state.logininfo);
  const {checkShow}=useSelector((state)=>state.helpdialog);
  const {num}=useSelector((state)=>state.crsytal);
  const {ti,tt}=useSelector((state)=>state.tabplate);
  
  const dispatch=useDispatch()
  const target = useRef(null);

  // 防止useEffect执行两次
  const hasFetched = useRef(false);
  
  // 控制帮助面板显示和显示的内容
  const {flag,content,id,node,nodeold}=useSelector((state)=>state.helpinfo);

  const [popoverTitle, setPopoverTitle] = useState({});
  const [modalShow1, setModalShow1] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);

  // 存放原题目（二层数组）
  let tiArray=useRef(null);
  // 存放答案
  let tiResult=useRef(null);
  // 是否有答案
  let isResult=useRef(false);
  
  useEffect(() => {
    if(hasFetched.current) return;
    if(expires<Date.now()) return;
    serGetCrsytalNum({name:usern})
    .then(res =>{
      const code=res.code;
      if(code===40){
        const data=res.data;
        dispatch(setCrsytalS(data))
      };
    })
    .catch(err =>{
      console.log(err.message);
    });
    hasFetched.current = true
  }, []);

  useEffect(() => {
    if(expires<Date.now()){
      dispatch(setHelpFlag(0))
    }
  }, [expires]);
  
  useEffect(() => {
    // 题目数组[[0,1,2,0,0,0,2,4,5],[...],...]
    tiArray.current=timuArray(ti);
    // 答案数组
    tiResult.current=timuArray(ti);
    // 获取答案，如果没有答案，返回false;
    isResult.current=solve(tiResult.current)
  }, [ti]);

  const navigate=useNavigate();
  const handleToAgree = (str)=>{
    navigate('/agreement',{replace:true,state:{str}});
  }

  // 弹窗一取消按钮
  const handleModalClose=()=>{
    setModalShow1(false);
  }
  // 弹窗一确定按钮
  const handleModalAgreed=()=>{
    setModalShow1(false);
    // 把题目保存到数据库
    serSetSubject({usern,ti})
    .then(res =>{
      const code=res.code;
      if(code===55){
        sendHelpDate ();
      };
    })
    .catch(err =>{
      setPopoverTitle({mark:1,message:`${langList.public8[lg]}`})
    });
    
  };

  // 请求和响应服务器数据
  function sendHelpDate (){
    dispatch(setHelpFlag(1))

    // 解答+题目
    // 数组[['e0','k1','t2','e0','e0','e0','t2','t4','t5'],[...],...]
    const tiKoArray=timuKoArray(tt);

    // 候选+解答+题目
    // 数组[['e0','k1','t2','h34567','e0','e0','t2','t4','t5'],[...],...]
    const tiHxArray=timuHxArray(tt);

    // 候选数背景色情况
    const scArray=toScArray(tt)

    // 当前盘面的阶段
    let jedn='gc';// gc表示观察法
    if(isAllCandidate(tt))jedn='hx'// hx表示候选数法

    serGetseekHelp({
      ti:tiArray.current,tiko:tiKoArray,tihx:tiHxArray,
      resu:tiResult.current,jedn,scA:scArray
    })
    .then(res =>{
      const code=res.code;
      if(code===52){
        const content=res.data.content[lg]
        const id=res.data.helpid
        const nodde=res.data.node
        dispatch(setHelpContent({flag:2,content,id,node:nodde,nodeold:nodde}))
      }else if(code===53){
        const content=res.data.content[lg]
        const id=res.data.helpid
        dispatch(setHelpContent({flag:2,content,id,node:null,nodeold:null}))
      };
    })
    .catch(err =>{
      if(err.code===100){
        setPopoverTitle({mark:1,message:`${langList.buttbar7[lg]}`})
        dispatch(setHelpFlag(flag))
      }else if(err.code===302){
        // 响应该超时
        dispatch(setHelpContent({flag:2,content:langList.helpplate8[lg],id:0,node:null,nodeold:null}))
      }else{
        setPopoverTitle({mark:3,message:`${langList.public8[lg]}`})
      }
    });
  };

  // 寻求帮助按钮
  const handleClick = ()=>{
    if(flag===1)return;
    if (Object.keys(popoverTitle).length !== 0)return;
    if(expires<Date.now()){
      setPopoverTitle({mark:2,message:langList.helpplate7[lg]})
      return;
    };
    if(ti==='0')return;
    if(ti.replace(/[0]/g,'').length<17)return;
    if(isComplate(tt))return;
    // 检查当前题是否正确
    if(!isResult.current){
      dispatch(setHelpContent(
        {flag:2,content:langList.helpplate4[lg],id:1,node:null,nodeold:null}
      ))
      return;
    };  
    // 检查当前的解答是否正确
    let point
    point=isKoError(tt,tiResult.current)
    if(point){
      dispatch(setHelpContent({flag:2,content:`${langList.helpplate5[lg]}`
        +AB(point.r,point.c),id:2,node:null,nodeold:null}))
      return;
    }
    //检查当天解题情况
    serIsSubject({usern,ti})
    .then(res =>{
      const code=res.code;
      if(code===54){
        const backData=res.data
        if(backData==='0'){
          // 不需要消耗水晶
          if(!checkShow){
            setModalShow2(true);
          }else{
            sendHelpDate ();
          }
        }else{
          // 需要消耗水晶
          setModalShow1(true);
        };
      };
    })
    .catch(err =>{
      if(err.code===100){
        setPopoverTitle({mark:1,message:`${langList.buttbar7[lg]}`})
        dispatch(setHelpFlag(flag))
      }else{
        setPopoverTitle({mark:3,message:`${langList.public8[lg]}`})
      }
    });

  };

  const handleContentClick = ()=>{
    if(flag!==2)return;
    if(node!==null){
      dispatch(setHelpNode(null))
    }else{
      dispatch(setHelpNode(nodeold))
    }
  }

  // 弹窗二中Check按钮
  const handleModalCheckChange=()=>{
    dispatch(setCheckShow(!checkShow));
  };
  // 弹窗二确定按钮
  const handleModalShow=()=>{
    setModalShow2(false);
    sendHelpDate ();
  };

  if (Object.keys(popoverTitle).length !== 0) {
    setTimeout(() => {
      setPopoverTitle({});
    }, 5000);
  }

  return (
    <Alert variant="secondary" style={{backgroundColor:hp}}>
      <div className="d-flex justify-content-between">
        <Button  variant="outline-dark"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          ref={target} onClick={handleClick}
        >
          <span className='fw-bold'>{langList.helpplate1[lg]}</span>
          <img src='./pic/question-lg.svg' alt='' width={'20px'}
          className='pb-1'
          style={{ filter: isHovered ? 'invert(100%)' : 'none' }}/>
        </Button>
        {expires>Date.now() && 
        <Button
          variant="link"
          style={{textDecoration: 'none',color: 'black'}}
        >
          <span className="me-2">{num}</span>
          <img src='./pic/gem.svg' alt='' width={'20px'} className='pb-1'/>
        </Button>
        }
      </div>
      <hr/>
      <div tabIndex={0} style={{cursor: "pointer"}} onClick={handleContentClick}>
        <div className={flag===0?'d-black':'d-none'}>
          {langList.helpplate2[lg]}
          <Badge bg="secondary" className='mx-1'>{langList.helpplate1[lg]} ？</Badge>
          {langList.helpplate3[lg]}
        </div>
        <div className={`${flag===1?'d-black':'d-none'} d-flex justify-content-center`}>
          <Spinner animation="border" variant="primary" />
        </div>
        <div className={flag===2?'d-black':'d-none'}>
          {content.split('<br/>').map((line, index) => (
          <div key={index} className="text-wrap">
            {line}
          </div>
          ))}
        </div>
      </div>
      <div className='d-flex justify-content-start mt-2'>
        <img src='./pic/question-square.svg' alt='' width={'20px'}/>
        <Button variant="link"
          onClick={()=>handleToAgree(lg+(id+2))}>
          {langList[`answerhelp${id}`][lg]}
        </Button>
      </div>
      {/* mark=1是杯子图标；2是圆形包裹!号图标；3是√图标 */}
      <Alertwin nu={{target:target,place:"top",title:popoverTitle.message,mark:popoverTitle.mark}} />
      <Modal show={modalShow1} backdrop="static" onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{langList.tabbr1[lg]}</Modal.Title>
        </Modal.Header>
        {/* <Modal.Body>当前寻求帮助会消耗 1 颗水晶。</Modal.Body> */}
        <Modal.Body>{langList.tabbr3[lg]}</Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={handleModalClose}>取消</Button> */}
          <Button variant="primary" onClick={handleModalAgreed}>{langList.public9[lg]}</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={modalShow2} backdrop="static">
        <Modal.Header>
          <Modal.Title>{langList.tabbr1[lg]}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{langList.tabbr4[lg]}</Modal.Body>
        <Modal.Footer className='d-flex justify-content-between align-items-center'>
          <Form.Check
            id='modalcheck1' type='checkbox'
            label={langList.tabbr5[lg]}
            checked={checkShow}
            onChange={handleModalCheckChange}
          />
          <Button variant="primary" onClick={handleModalShow}>{langList.public9[lg]}</Button>
        </Modal.Footer>
      </Modal>
    </Alert>
  )
}
